import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { apiAction as detachBusinessAdminApiAction, default as detachBusinessAdminConfig } from './detachBusinessAdmin';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  USER: {
    UPDATE_PAYMENT_DETAILS: (source, detachBusinessAdmin) => ({ source, detachBusinessAdmin }),
    API: {
      UPDATE_PAYMENT_DETAILS: apiResourceActionCreator('subscription')
    }
  }
})

export const apiAction = (authToken, newPayment) => commonApiActions.authenticated.post(`${API_ENDPOINT}/update-payment`, authToken, newPayment, actions.user.api.updatePaymentDetails)

export function* updateUserPayment(action) {
  const authToken = yield select(authTokenSelector);
  const { detachBusinessAdmin } = action.payload;

  if (detachBusinessAdmin) {
    yield put(detachBusinessAdminApiAction(authToken));

    const detachBusinessAdminResult = yield apiActionResult(detachBusinessAdminConfig.action.user.api.detachBusinessAdmin);

    if (detachBusinessAdminResult.success) {
      yield put(apiAction(authToken, action.payload));
    }
  }
  else {
    yield put(apiAction(authToken, action.payload));
  }
}

const configuration = {
  name: 'updatePaymentDetails',
  action: actions,
  sagas: updateUserPayment,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true,
      isUpdating: true
    }),
    success: (state, action) => ({
      ...state,
      error: null,
      currentSubscription: action.payload.subscription,
      isFetching: false,
      isUpdating: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isUpdating: false,
      isFetching: false
    }),
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/updatePaymentDetails.js